export class RedemptionAndCapitalizations {
    constructor(
        public OfferID?: Number,
        public RCTable?: String) { }
}